module.exports = __webpack_public_path__ + "static/media/coffee-milk.b27ee13f.webp";